import { Nemesis } from '../../../../aer-types/types'

export const nemeses: Nemesis[] = [
  {
    expansion: 'O',
    name: 'Eksperyment 153',
    id: 'Experiment153',
    health: '*',
    difficulty: 3,
    expeditionRating: 1,
    additionalInfo: '',
  },
  {
    expansion: 'O',
    name: 'Złodziej Snów',
    id: 'ThiefOfDreams',
    health: 80,
    difficulty: 4,
    expeditionRating: 2,
    additionalInfo: '',
  },
  {
    expansion: 'O',
    name: 'Ożywiony Sługa',
    id: 'RisenThrall',
    health: 50,
    difficulty: 5,
    expeditionRating: 3,
    additionalInfo: '',
  },
  {
    expansion: 'O',
    name: 'Fontanna Dusz',
    id: 'FountainOfSouls',
    health: 70,
    difficulty: 8,
    expeditionRating: 4,
    additionalInfo: '',
  },
]
